import { useEffect } from "react";
import { AddProductScreenViewModel } from "../../../../viewmodels/setup/products/AddProductScreenViewModel";

import { connect } from "react-redux";

import { useNavigate } from "react-router-dom";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import SlideOver from "../../../../components/slideOver/SlideOver";
import EmptyModal from "../../../../components/modals/EmptyModal";

import ProductDetailsForm from "../../../../components/forms/setup/products/ProductDetailsForm";

function AddProductScreen(props) {
  const { addSnackbar, logout } = props;

  const navigate = useNavigate();

  const {
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    inventoryTypeOptions,
    getInventoryTypes,
    classTypeOptions,
    categoryOptions,
    boxTypeOptions,
    allergenOptions,
    warehouseOptions,
    warehouseLocationsOptions,
    getClassTypes,
    getCategoryTypes,
    getBoxTypes,
    getAllergens,
    getWarehouses,
    getWarehouseLocations,
    createProduct,
    graphicsOptions,
    getGraphics,
    getProductColours,
    getProductOdours,
    getProductTastes,
    productColours,
    productOdours,
    productTastes,
    taxRates,
    getTaxRatesForDropdown,
  } = AddProductScreenViewModel(logout, addSnackbar, navigate);

  useEffect(() => {
    getInventoryTypes();
    getClassTypes();
    getCategoryTypes();
    getBoxTypes();
    getAllergens();
    getWarehouses();
    getGraphics();
    getProductColours();
    getProductOdours();
    getProductTastes();
    getTaxRatesForDropdown();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-2xl font-semibold leading-6 text-gray-900">
              Add product
            </h1>
          </div>
          <ProductDetailsForm
            product={null}
            actionCall={createProduct}
            isEdit={false}
            inventoryTypeOptions={inventoryTypeOptions}
            classTypeOptions={classTypeOptions}
            categoryOptions={categoryOptions}
            boxTypeOptions={boxTypeOptions}
            allergenOptions={allergenOptions}
            warehouseOptions={warehouseOptions}
            warehouseLocationsOptions={warehouseLocationsOptions}
            getWarehouseLocations={getWarehouseLocations}
            graphicsOptions={graphicsOptions}
            productColours={productColours}
            productOdours={productOdours}
            productTastes={productTastes}
            taxRates={taxRates}
          />
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddProductScreen)
);
